module.exports = __webpack_public_path__ + "img/hld.a1b33256.png";